var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass:
          "panel-block is-flex is-justify-content-space-between custom-panel pnet-panel-border pb-3",
        class: [
          {
            "custom-panel-with-no-chart": _vm.isUninvoicedJobsAndChartDisabled,
          },
        ],
      },
      [
        _c("p", { staticClass: "is-flex is-align-items-center" }, [
          _vm._v("PNET"),
        ]),
      ]
    ),
    _c("div", { staticClass: "panel-block custom-panel" }, [
      _c(
        "div",
        {
          staticClass: "column message-item clickable-message",
          on: {
            click: function ($event) {
              return _vm.onClick(_vm.messageStatusTypes.UnRead)
            },
          },
        },
        [
          _c("span", { staticClass: "is-size-7" }, [_vm._v("Inbox")]),
          _c("DashboardWebServiceCircularStatus", {
            attrs: {
              value: _vm.pnet?.unRead,
              "color-code": _vm.getButtonColorCode(
                _vm.pnet?.unRead,
                _vm.isGreen
              ),
              width: "40px",
              height: "40px",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "column message-item clickable-message",
          on: {
            click: function ($event) {
              return _vm.onClick(_vm.messageStatusTypes.ToSend)
            },
          },
        },
        [
          _c("span", { staticClass: "is-size-7" }, [_vm._v("Failed")]),
          _c("DashboardWebServiceCircularStatus", {
            attrs: {
              value: _vm.pnet?.sendFailed,
              "color-code": _vm.getButtonColorCode(
                _vm.pnet?.sendFailed,
                _vm.isRed
              ),
              width: "40px",
              height: "40px",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "column message-item clickable-message",
          on: {
            click: function ($event) {
              return _vm.onClick(_vm.messageStatusTypes.ToSend)
            },
          },
        },
        [
          _c("span", { staticClass: "is-size-7" }, [_vm._v("Outbox")]),
          _c("DashboardWebServiceCircularStatus", {
            attrs: {
              value: _vm.pnet?.toSend,
              "color-code": _vm.getButtonColorCode(
                _vm.pnet?.sendFailed,
                _vm.isGray
              ),
              width: "40px",
              height: "40px",
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "column" }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }